import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  inset?: boolean;
}

export function Card({ children, inset = true, className = '', ...rest }: CardProps) {
  return (
    <div
      {...rest}
      className={[
        'bg-card border border-line rounded-xl',
        inset ? 'p-6' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}
